const initialState = {
    shop: {},
    branches: [],
};
const selectBranch = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SELECT_BRANCH':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default selectBranch;
